import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";
import { FaBars, FaRegUserCircle, FaTimes } from "react-icons/fa";
import logo from "../assets/simiLogo.png";
import { CiShoppingCart, CiUser } from "react-icons/ci";
import { motion, AnimatePresence } from "framer-motion"; // Added for smooth modal

const Navbar = () => {
  const [toggle, setToggle] = useState(false);
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false); // Modal State
  const handleToggle = () => setToggle(!toggle);
  const [activeTab, setActiveTab] = useState("home");
  const location = useLocation();
  const pathname = location.pathname;
  const [isVisible, setIsVisible] = useState(false);

  const openBooking = (url) => {
    window.open(url, "_blank");
    setIsBookingModalOpen(false);
  };

  // Function to close mobile menu when a link is clicked
  const closeMobileMenu = () => {
    setToggle(false);
  };

  useEffect(() => {
    if (pathname === "/") setActiveTab("home");
    // else if (pathname === "/academy") setActiveTab("academy");
    else if (pathname === "/about-me") setActiveTab("about-me");
    else if (pathname === "/leistungen") setActiveTab("leistungen");
    else if (pathname === "/schulungen") setActiveTab("schulungen");
    else if (pathname === "/kontakt") setActiveTab("kontakt");
    else setActiveTab("");
  }, [pathname]);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  // Close mobile menu when route changes (as a fallback)
  useEffect(() => {
    setToggle(false);
  }, [pathname]);

  return (
    <>
      <Container className={isVisible ? "visible" : ""}>
        <div className="logo-container">
          <Link to={"/"} className="link-styles" onClick={closeMobileMenu}>
            <img src={logo} alt="Logo" />
          </Link>
        </div>

        <ul className="nav-menu-center">
          <Link to={"/"} className="link-styles">
            <li className={activeTab === "home" ? "activeTab" : "nonActive"}>
              Home
            </li>
          </Link>

          {/* TRIGGER MODAL INSTEAD OF LINK */}
          <Link to={"/about-me"} className="link-styles">
            <li
              className={activeTab === "about-me" ? "activeTab" : "nonActive"}
            >
              About Me
            </li>
          </Link>

          <Link to={"/leistungen"} className="link-styles">
            <li
              className={activeTab === "leistungen" ? "activeTab" : "nonActive"}
            >
              Leistungen
            </li>
          </Link>
          <Link to={"/schulungen"} className="link-styles">
            <li
              className={activeTab === "schulungen" ? "activeTab" : "nonActive"}
            >
              Schulungen
            </li>
          </Link>
        </ul>
        <div className="nav-buttons">
          {/* <Link to={"/login"} className="link-styles">
            <button className="login">Log In</button>
          </Link> */}
          <Link to={"/kontakt"} className="link-styles">
            <button>Kontakt</button>
          </Link>
        </div>

        <div className="mobile-menu" onClick={handleToggle}>
          {toggle ? <FaTimes className="icon" /> : <FaBars className="icon" />}
        </div>

        {/* Mobile menu */}
        <ul className={toggle ? "nav-menu-mobile active" : "nav-menu-mobile"}>
          <Link to={"/"} onClick={closeMobileMenu} className="link-styles">
            <li>Home</li>
          </Link>
          <Link
            to={"/about-me"}
            onClick={closeMobileMenu}
            className="link-styles"
          >
            <li>About me</li>
          </Link>
          <Link
            to={"/leistungen"}
            onClick={closeMobileMenu}
            className="link-styles"
          >
            <li>Leistungen</li>
          </Link>
          <Link
            to={"/schulungen"}
            onClick={closeMobileMenu}
            className="link-styles"
          >
            <li>Schulungen</li>
          </Link>
          <Link
            to={"/kontakt"}
            onClick={closeMobileMenu}
            className="link-styles"
          >
            <button>Kontakt</button>
          </Link>
        </ul>
      </Container>

      {/* --- BOOKING SELECTION MODAL --- */}
      <AnimatePresence>
        {isBookingModalOpen && (
          <ModalOverlay
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setIsBookingModalOpen(false)}
          >
            <ModalContent
              initial={{ scale: 0.9, opacity: 0, y: 20 }}
              animate={{ scale: 1, opacity: 1, y: 0 }}
              exit={{ scale: 0.9, opacity: 0, y: 20 }}
              onClick={(e) => e.stopPropagation()}
            >
              <CloseBtn onClick={() => setIsBookingModalOpen(false)}>
                &times;
              </CloseBtn>
              <h3>Termin buchen</h3>
              <p>Wählen Sie Ihre bevorzugte Buchungsplattform:</p>

              <ButtonGroup>
                <PlatformBtn
                  onClick={() =>
                    openBooking(
                      "https://buchung.treatwell.de/ort/era-aesthetics-academy/",
                    )
                  }
                >
                  <span>Treatwell</span>
                  <small>Schnelle Online-Buchung</small>
                </PlatformBtn>

                <PlatformBtn
                  onClick={() =>
                    openBooking(
                      "https://beautinda.de/artist/glAjRxw9FkUTkPh98ZNpnvDTdqV2",
                    )
                  }
                >
                  <span>Beautinda</span>
                  <small>Alternative Buchung</small>
                </PlatformBtn>
              </ButtonGroup>
            </ModalContent>
          </ModalOverlay>
        )}
      </AnimatePresence>
    </>
  );
};

// --- MODAL STYLES ---

const ModalOverlay = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(109, 99, 87, 0.5);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
`;

const ModalContent = styled(motion.div)`
  background: #fdfcfb;
  padding: 2.5rem;
  border-radius: 30px;
  max-width: 450px;
  width: 100%;
  text-align: center;
  position: relative;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
  border: 1px solid #e9e3d0;

  h3 {
    font-family: "Playfair Display", serif;
    font-size: 1.8rem;
    color: #5a5248;
    margin-bottom: 0.5rem;
  }
  p {
    color: #6d6357;
    margin-bottom: 2rem;
    font-size: 0.95rem;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const PlatformBtn = styled.button`
  background: #fdfcfb;
  border: 1px solid rgba(109, 99, 87, 0.2);
  padding: 16px;
  border-radius: 15px;
  cursor: pointer;
  transition: all 0.3s ease;

  span {
    display: block;
    font-size: 1.1rem;
    font-weight: 600;
    color: #5a5248;
  }
  small {
    color: #857869;
    font-size: 0.75rem;
    text-transform: uppercase;
  }

  &:hover {
    background: #6d6357;
    span,
    small {
      color: white;
    }
  }
`;

const CloseBtn = styled.button`
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #5a5248;
  cursor: pointer;
  opacity: 0.5;
  &:hover {
    opacity: 1;
  }
`;
const Container = styled.div`
  position: fixed;
  top: 1em;
  left: 50%;
  transform: translateX(-50%) translateY(-20px);

  width: 80%;
  height: 60px;
  padding: 1% 4%;

  display: flex;
  justify-content: space-between;
  align-items: center;

  backdrop-filter: blur(7px);
  -webkit-backdrop-filter: blur(7px);
  background-color: #cfc0afad;

  border-radius: 30px;
  border: 2px solid #e9e3d0;
  box-shadow: 0 0 11px 2px #e2e1e2ce;

  box-sizing: border-box;
  z-index: 100;

  opacity: 0;
  transition:
    opacity 0.5s ease-out,
    transform 0.5s ease-out;

  &.visible {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }

  /* ---------- RESPONSIVE WIDTH ---------- */
  @media (max-width: 1919px) {
    width: 90%;
  }

  @media (max-width: 750px) {
    width: 90%;
  }

  /* ---------- LOGO ---------- */
  .logo-container {
    flex: 1;
    display: flex;
    align-items: center;

    img {
      height: 40px;
      margin-top: 10px;
      transition: transform 0.3s ease;

      &:hover {
        transform: scale(1.05);
      }
    }
  }

  /* ---------- CENTER MENU ---------- */
  .nav-menu-center {
    flex: 3;
    display: flex;
    justify-content: center;
    gap: 37px;
    list-style: none;
    margin: 0;
    padding: 0;

    li {
      color: #6d6357;
      font-weight: 400;
      cursor: pointer;
      padding: 8px 16px;
      border-radius: 20px;
      transition: all 0.3s ease;

      &:hover {
        background-color: rgba(109, 99, 87, 0.1);
        transform: translateY(-2px);
      }
    }

    .activeTab {
      text-decoration: underline;
      text-underline-offset: 7px;
      font-weight: 600;
    }

    .link-styles {
      text-decoration: none;
    }
  }

  /* ---------- BUTTONS ---------- */
  .nav-buttons {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    gap: 15px;

    button {
      border: none;
      background: #6d6357;
      padding: 8px 24px;
      color: white;
      font-size: 16px;
      border-radius: 20px;
      cursor: pointer;
      transition: all 0.4s ease;

      &:hover {
        box-shadow: 0 0 14px 2px rgba(109, 99, 87, 0.3);
        transform: translateY(-2px);
      }
    }
  }

  /* ---------- MOBILE MENU ICON ---------- */
  .mobile-menu {
    position: absolute;
    right: 5%;
    font-size: 24px;
    cursor: pointer;
    display: none;
    color: #6d6357;
    z-index: 9999999999999999;
  }

  /* ---------- MOBILE NAV ---------- */
  .nav-menu-mobile {
    background: #f2efe4;
    width: 90%;
    height: 100vh;
    position: fixed;
    top: 0;
    right: -120%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    transition: right 0.3s ease;
    z-index: 99;

    &.active {
      right: -10%;
    }

    li {
      padding: 15px 30px;
      margin: 10px 0;
      border-radius: 25px;
      cursor: pointer;
      color: #6d6357;
      list-style: none;

      &:hover {
        background-color: rgba(109, 99, 87, 0.1);
      }
    }
    button {
      border: none;
      background: #6d6357;
      padding: 8px 24px;
      color: white;
      font-size: 16px;
      border-radius: 20px;
      cursor: pointer;
      transition: all 0.4s ease;

      &:hover {
        box-shadow: 0 0 14px 2px rgba(109, 99, 87, 0.3);
        transform: translateY(-2px);
      }
    }
  }

  @media (max-width: 1410px) {
    .nav-menu-center,
    .nav-buttons {
      display: none;
    }

    .mobile-menu {
      display: block;
    }
  }
`;

const UserPill = styled.div`
  max-width: 240px;
  padding: 8px 14px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.55);
  border: 1px solid rgba(109, 99, 87, 0.2);
  color: #6d6357;
  font-size: 0.85rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export default Navbar;
